import styled, { css } from 'styled-components';
import { Button } from '../../input/Button';

export const CpaButton = styled(Button)
    .withConfig({ displayName: 'CpaButton' })
    .attrs((props) => ({
        height: '40px',
        ...props,
    }))<{ isLoading?: boolean }>`
    letter-spacing: 0.7px;

    ${({ isLoading }) =>
        isLoading &&
        css`
            min-width: 165px;
        `}
`;
